/**
 * Permanent `/signup` → `/login?mode=signup` redirect.
 *
 * `/signup` used to be a second, older account-creation form with no social
 * auth at all. The page is gone, but its URLs are NOT: `NetworkPage` builds
 * `${origin}/signup?ref=<userId>` invite links that users copy and send to
 * other people, `ReferralInvitePage` builds `?referralInviteToken=…` ones, and
 * `organization-workflow.ts` puts
 * `/signup?orgInviteToken=…&email=…&firstName=…&lastName=…` into team-invite
 * emails. Those links are outside our control, so this route stays
 * indefinitely — deleting it would 404 invitations that are already sent.
 *
 * Every query param is carried across untouched; the combined page reads
 * `ref`, `trial`, `referralInviteToken`, `orgInviteToken`, `email`,
 * `firstName`, `lastName` and `redirect`. `mode=signup` is added so the user
 * lands on the sign-up tab rather than sign-in.
 */

import { Navigate, useLocation } from 'react-router-dom';

export default function SignupRedirect() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  // set(), not append(): an inbound `?mode=signin` would otherwise survive and
  // land someone following a signup link on the wrong tab.
  params.set('mode', 'signup');

  // `replace` keeps the dead path out of history, so Back goes where the user
  // came from instead of bouncing through the redirect again. The hash is
  // preserved because an auth round-trip can carry tokens there.
  return <Navigate to={`/login?${params.toString()}${location.hash}`} replace />;
}
